<p>
  especialidad-dialog works!
</p>
